export default __webpack_public_path__ + "static/media/17-1.e4a4095d.jpg";